import { TextProps } from '@app/types'
import { Typography } from 'antd'

export const Text: React.FC<TextProps> = (props) => <Typography.Text {...props} />
